<stx-generic-wide-page>
  <stx-report-header>
    {{ 'reports.photo_report' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>

  @if (reportService.initialized$ | async) {
  <stx-photo-report-table></stx-photo-report-table>
  }
</stx-generic-wide-page>
